<table class="table table-bordered table-bottom">
  <tr>
    <th class="active detail-top-title" colspan="2">
      <ng-container *ngIf="isSettingLineRichTemplate">
        案内文の種類と内容を設定してください。
      </ng-container>
      <ng-container *ngIf="!isSettingLineRichTemplate">
        本文の設定をしてください。
      </ng-container>
    </th>
  </tr>
  <tr *ngIf="!isSettingLineRichTemplate">
    <th>件名</th>
    <td>
      <div class="form-item_half">
        <bl-text-input
          [(value)]="entity && entity.dmContentTitle"
          maxlength="40"
          [validator]="blFormGroup.validatorGroup['DmContentInfo#dmContentTitle']"
          (changeEvent)="notifyChange()"
        ></bl-text-input>
      </div>
    </td>
  </tr>
  <tr *ngIf="!isSettingLineRichTemplate">
    <th>本文</th>
    <td>
      <div class="dm-content-body-textarea">
        <bl-textarea
          [(value)]="entity && entity.dmContentBody"
          rows="5"
          maxlength="5000"
          [addClass]="'content-body-textarea'"
          [validator]="blFormGroup.validatorGroup['DmContentInfo#dmContentBody']"
          (changeEvent)="notifyChange()"
        ></bl-textarea>
      </div>
    </td>
  </tr>
  <!-- リッチ版LINEテンプレート -->
  <tr *ngIf="isSettingLineRichTemplate">
    <table class="table-rich-section">
      <tr #dmSnsMsgSettingList *ngFor="let ex of _dmSnsMsgSettingExList; let idx = index">
        <!-- コンテキストメニュー -->
        <td class="context-menu">
          <div blContextMenu #contextMenuList class="context-menu__column" tabindex="0"
            [items]="getContextMenuList(idx)"
            (selectItemEvent)="onSelectMenu($event, idx)"
            >
            <span class="icon-icon_grid_edit"></span>
          </div>
        </td>
        <td class="dm-sns-msg-body-type">
          <div class="dm-sns-msg-body-form">
            <div class="dm-sns-msg-body-form__type">
              <label>案内文{{ ex.dmSnsMsgSetting.itemNumber }}</label>
              <!-- ラジオボタン -->
              <div class="dm-sns-msg-body-form__radio">
                <bl-radio-group
                  [value]="ex.dmSnsMsgSetting.dmSnsMsgBodyTypeDiv"
                  [items]="DmSnsMsgBodyTypeItems"
                  (changeEvent)="onChangeDmSnsMsgBodyType($event, ex.dmSnsMsgSetting, idx)"
                ></bl-radio-group>
              </div>
            </div>
          </div>
        </td>
        <td>
          <!-- セル -->
          <ng-container *ngIf="ex.dmSnsMsgSetting.dmSnsMsgBodyTypeDiv === DmSnsMsgBodyType.Text">
            <ng-container *ngTemplateOutlet="
              normalTextCell;
              context: {
                $implicit: { dmSnsMsgSetting: ex.dmSnsMsgSetting, ex: ex, index: idx } } "
            ></ng-container>
          </ng-container>
          <ng-container *ngIf="ex.dmSnsMsgSetting.dmSnsMsgBodyTypeDiv === DmSnsMsgBodyType.FlexMessage ">
            <ng-container *ngTemplateOutlet=" flexMsgTextCell;
                context: { $implicit: { dmSnsMsgSetting: ex.dmSnsMsgSetting, ex: ex, index: idx } } " ></ng-container>
          </ng-container>
          <ng-container *ngIf="ex.dmSnsMsgSetting.dmSnsMsgBodyTypeDiv === DmSnsMsgBodyType.Image ">
            <ng-container *ngTemplateOutlet=" imageCell; context: { $implicit: { dmSnsMsgSetting: ex.dmSnsMsgSetting, index: idx } } "></ng-container>
          </ng-container>
        </td>
      </tr>
    </table>
    <div class="message-config__add">
      <button class="btn btn-success" (click)="onAddDmSnsMsgSetting()" *ngIf="_dmSnsMsgSettingExList.length < 3">+ 追加する</button>
      <span class="message-config__label">※一度の送信に3点まで設定できます。</span>
    </div>
  </tr>
</table>

<!-- 通常テキストセル -->
<ng-template #normalTextCell let-data>
  <div class="normal-text-cell">
    通常のフキダシメッセージテキスト(最大全角：{{ normalMessaageLength }}文字)
    <br>
    <bl-textarea
      class="normal-text-cell__text"
      [maxlength]="normalMessaageLength"
      [(value)]="data.dmSnsMsgSetting.dmSnsMsgBody"
      [validator]="getValidator('DmSnsMsgSetting#dmSnsMsgBody', data.index)"
      (changeEvent)="notifyChange()"
      (inputEvent)="onInputNormalTextarea($event, data.ex)"
      (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.NormalText)"
    ></bl-textarea>
    <div class="inline-flex">
      <div class="textarea-bottom-emoji">
        <bl-emoji-picker-button
          (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.NormalText)"
        ></bl-emoji-picker-button>絵文字入力
      </div>
      <div class="dm-notice-position">
        <div [ngClass]="{ 'dm-language-color': !data.ex.isStyleDisabled }">
          残り&nbsp;
          <div
            class="dm-count-postion"
            [ngClass]="{ 'dm-notice-color': !data.ex.isStyleDisabled }"
          >
            {{ data.ex.count }}
          </div>
          &nbsp;/&nbsp;{{ normalMessaageLength }}&nbsp;文字&nbsp;<br />
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- フレックスメッセージセル -->
<ng-template #flexMsgTextCell let-data>
  <table class="table flex-msg-cell">
    <tr>
      <th>タイプ</th>
      <td>
        <div class="inline-flex">
          <div class="flex-msg-cell__type">
            <bl-guide-label #lineMsgTemplateGuideLabel
              [value]="data.ex.dispLineMsgTemplateName"
              [labelText]="data.ex.dispLineMsgTemplateName"
              [validator]="getValidator('DmSnsMsgSetting#lineMsgTemplateType', data.index)"
              [hideDelete]="true"
              (clickGuideEvent)="onShowLineMsgTemplateGuide(data.index, lineMsgTemplateGuideLabel)"
            ></bl-guide-label>
          </div>
          <div class="flex-msg-cell__type__subimage">
            <img [src]="data.ex.lineMsgTemplateImageUrl">
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <th>件名</th>
      <td>
        <div class="inline-flex" *ngIf="data.ex.isEnabledSetTitleInFlex">
          <div class="flex-msg-cell__title">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgTitle"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgTitle', data.index)"
              (changeEvent)="onInputRichTitle($event, data.ex)"
              (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexTitle)"
            ></bl-text-input>
          </div>
          <div class="textarea-bottom-emoji emoji-picker__title-side">
            <bl-emoji-picker-button
              (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.FlexTitle)"
            ></bl-emoji-picker-button>絵文字入力
          </div>
        </div>
        <div>
          プッシュ通知やチャットタイトルには下記を表示します。
        </div>
        <div class="flex-msg-cell__notify-disp-title">
          <bl-text-input
            [(value)]="data.dmSnsMsgSetting.dmSnsMsgNotifyDispTitle"
            [validator]="getValidator('DmSnsMsgSetting#dmSnsMsgNotifyDispTitle', data.index)"
            (changeEvent)="notifyChange()"
            (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexPushNotifyTitle)"
          ></bl-text-input>
        </div>
      </td>
    </tr>
    <!-- 件名2 -->
    <tr *ngIf="data.ex.isEnabledSetTitle2InFlex">
      <th>件名2</th>
      <td>
        <div class="inline-flex">
          <div class="flex-msg-cell__title">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgTitle2"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgTitle2', data.index)"
              (changeEvent)="notifyChange()"
              (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexTitle2)"
            ></bl-text-input>
          </div>
          <div class="textarea-bottom-emoji emoji-picker__title-side">
            <bl-emoji-picker-button
              (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.FlexTitle2)"
            ></bl-emoji-picker-button>絵文字入力
          </div>
        </div>
      </td>
    </tr>
    <!-- 件名3 -->
    <tr *ngIf="data.ex.isEnabledSetTitle3InFlex">
      <th>件名3</th>
      <td>
        <div class="inline-flex">
          <div class="flex-msg-cell__title">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgTitle3"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgTitle3', data.index)"
              (changeEvent)="notifyChange()"
              (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexTitle3)"
            ></bl-text-input>
          </div>
          <div class="textarea-bottom-emoji emoji-picker__title-side">
            <bl-emoji-picker-button
              (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.FlexTitle3)"
            ></bl-emoji-picker-button>絵文字入力
          </div>
        </div>
      </td>
    </tr>
    <!-- ラベル -->
    <tr *ngIf="data.ex.isEnabledSetLabelInFlex">
      <th>ラベル</th>
      <td>
        <div class="inline-flex">
          <div class="flex-msg-cell__title">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgLabel"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgLabel', data.index)"
              (changeEvent)="notifyChange()"
              (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexLabel)"
            ></bl-text-input>
          </div>
          <div class="textarea-bottom-emoji emoji-picker__title-side">
            <bl-emoji-picker-button
              (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.FlexLabel)"
            ></bl-emoji-picker-button>絵文字入力
          </div>
        </div>
      </td>
    </tr>
    <!-- ラベル2 -->
    <tr *ngIf="data.ex.isEnabledSetLabel2InFlex">
      <th>ラベル2</th>
      <td>
        <div class="inline-flex">
          <div class="flex-msg-cell__title">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgLabel2"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgLabel2', data.index)"
              (changeEvent)="notifyChange()"
              (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexLabel2)"
            ></bl-text-input>
          </div>
          <div class="textarea-bottom-emoji emoji-picker__title-side">
            <bl-emoji-picker-button
              (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.FlexLabel2)"
            ></bl-emoji-picker-button>絵文字入力
          </div>
        </div>
      </td>
    </tr>
    <tr *ngIf="data.ex.isEnabledSetBodyInFlex">
      <th>本文</th>
      <td>
        <div class="flex-msg-cell__body">
          <bl-textarea
            [maxlength]="retchMessaageLength"
            [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBody"
            [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgBody', data.index)"
            (inputEvent)="onInputRichTextarea($event, data.ex)"
            (changeEvent)="notifyChange()"
            (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexText)"
          ></bl-textarea>
        </div>
        <div class="inline-flex">
          <div class="textarea-bottom-emoji">
            <bl-emoji-picker-button
              (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.FlexText)"
            ></bl-emoji-picker-button>絵文字入力
          </div>
          <div class="dm-notice-position">
            <div [ngClass]="{ 'dm-language-color': !data.ex.isStyleDisabled }">
              残り&nbsp;
              <div
                class="dm-count-postion"
                [ngClass]="{ 'dm-notice-color': !data.ex.isStyleDisabled }"
              >
                {{ data.ex.count }}
              </div>
              &nbsp;/&nbsp;{{ retchMessaageLength }}&nbsp;文字&nbsp;<br />
            </div>
          </div>
        </div>
      </td>
    </tr>
    <!-- フッター -->
    <tr *ngIf="data.ex.isEnabledSetFooterInFlex">
      <th>フッター</th>
      <td>
        <div class="inline-flex">
          <div class="flex-msg-cell__title">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgFooter"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgFooter', data.index)"
              (changeEvent)="notifyChange()"
              (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexFooter)"
            ></bl-text-input>
          </div>
          <div class="textarea-bottom-emoji emoji-picker__title-side">
            <bl-emoji-picker-button
              (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.FlexFooter)"
            ></bl-emoji-picker-button>絵文字入力
          </div>
        </div>
      </td>
    </tr>
    <!-- フッター2 -->
    <tr *ngIf="data.ex.isEnabledSetFooter2InFlex">
      <th>フッター2</th>
      <td>
        <div class="inline-flex">
          <div class="flex-msg-cell__title">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgFooter2"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgFooter2', data.index)"
              (changeEvent)="notifyChange()"
              (blurEvent)="onBlurEmojiInputView($event, data.ex, EmojiInputItemType.FlexFooter2)"
            ></bl-text-input>
          </div>
          <div class="textarea-bottom-emoji emoji-picker__title-side">
            <bl-emoji-picker-button
              (selectEmojiEvent)="onSelectEmoji($event, data.ex, EmojiInputItemType.FlexFooter2)"
            ></bl-emoji-picker-button>絵文字入力
          </div>
        </div>
      </td>
    </tr>
    <tr *ngIf="data.ex.isEnabledSetImageInFlex">
      <th>画像</th>
      <td>
        <div>
          <share-attachment #flexMsgCellAttachment
            fontSize="14px"
            [fileManageInfos]="(data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgDispFile ?
              [data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgDispFile] : [])"
            [multiple]="false"
            [option]="shareImageOption"
            (appendEvent)="onAppendImage($event, data.index)"
            (removeEvent)="onRemoveImageFlex(data.index)"
          ></share-attachment>
        </div>
        <div>
          <bl-checkbox
            [(checked)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageActionValidFlag"
            label="画像押下を有効にする"
            [inline]="true"
            (changeEvent)="onChangeImageActionValidFlag($event, data.dmSnsMsgSetting)"
          ></bl-checkbox>
        </div>
        <div class="flex-msg-cell__action">
          <!-- 画像押下時のアクション -->
          <span>画像押下時の挙動</span>
          <div class="flex-msg-cell__action-radio">
            <bl-radio-group
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageActionDiv"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgImageActionDiv', data.index)"
              [items]="_dmSnsMsgBtnActionDivArray"
              [option]="{ labelProperty: 'text', valueProperty: 'value' }"
              [groupType]="'inline'"
              [disabled]="!data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageActionValidFlag"
              (changeEvent)="onChangeSnsMsgImageActionDiv(data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0])"
            ></bl-radio-group>
          </div>
        </div>
        <ng-container *ngIf="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageActionDiv === DmSnsMsgBtnActionDiv.Text">
          <div class="flex-msg-cell__action-text">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageSendText"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgImageSendText', data.index)"
              [disabled]="!data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageActionValidFlag"
              (changeEvent)="notifyChange()"
              placeholder="画像押下時に遷移するテキストを入力"
            ></bl-text-input>
          </div>
        </ng-container>
        <ng-container *ngIf="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageActionDiv === DmSnsMsgBtnActionDiv.Url">
          <div class="flex-msg-cell__action-url">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageTransitionUrl"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgImageTransitionUrl', data.index)"
              [disabled]="!data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgImageActionValidFlag"
              (changeEvent)="notifyChange()"
              placeholder="画像押下時に遷移するURLを入力"
            ></bl-text-input>
          </div>
        </ng-container>
      </td>
    </tr>
    <tr>
      <th>ボタン</th>
      <td>
        <div>
          <bl-checkbox
            [(checked)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnDispFlag"
            label="ボタンを有効にする"
            [inline]="true"
            (changeEvent)="onChangeBtnDispFlag($event, data.dmSnsMsgSetting)"
          ></bl-checkbox>
        </div>
        <!-- ボタン表示名 -->
        <div class="flex-msg-cell__button-text">
          <bl-text-input
            [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnDispName"
            [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgBtnDispName', data.index)"
            [disabled]="!data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnDispFlag"
            (changeEvent)="notifyChange()"
            placeholder="ボタンに表示するテキストを入力"
          ></bl-text-input>
        </div>
        <div class="flex-msg-cell__action">
          <!-- ボタン押下時のアクション -->
          <span>ボタン押下時の挙動</span>
          <div class="flex-msg-cell__action-radio">
            <bl-radio-group
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnActionDiv"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgBtnActionDiv', data.index)"
              [items]="_dmSnsMsgBtnActionDivArray"
              [option]="{ labelProperty: 'text', valueProperty: 'value' }"
              [groupType]="'inline'"
              [disabled]="!data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnDispFlag"
              (changeEvent)="onChangeSnsMsgBtnActionDiv(data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0])"
            ></bl-radio-group>
          </div>
        </div>
        <ng-container *ngIf="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnActionDiv === DmSnsMsgBtnActionDiv.Text">
          <div class="flex-msg-cell__action-text">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnSendText"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgBtnSendText', data.index)"
              [disabled]="!data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnDispFlag"
              (changeEvent)="notifyChange()"
              placeholder="ボタン押下時に遷移するテキストを入力"
            ></bl-text-input>
          </div>
        </ng-container>
        <ng-container *ngIf="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnActionDiv === DmSnsMsgBtnActionDiv.Url">
          <div class="flex-msg-cell__action-url">
            <bl-text-input
              [(value)]="data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgTransitionUrl"
              [validator]="getValidator('DmSnsMsgSettingDetail#dmSnsMsgTransitionUrl', data.index)"
              [disabled]="!data.dmSnsMsgSetting.dmSnsMsgSettingDetailList[0].dmSnsMsgBtnDispFlag"
              (changeEvent)="notifyChange()"
              placeholder="ボタン押下時に遷移するURLを入力"
            ></bl-text-input>
          </div>
        </ng-container>
      </td>
    </tr>
  </table>
</ng-template>

<!-- 画像メッセージセル -->
<ng-template #imageCell let-data>
  <div class="image-cell">
    <div>
      <share-attachment #imageCellAttachment
        fontSize="14px"
        [fileManageInfos]="(data.dmSnsMsgSetting.dmSnsMsgDispFile ? [data.dmSnsMsgSetting.dmSnsMsgDispFile] : [])"
        [multiple]="false"
        [option]="shareImageOption"
        (appendEvent)="onAppendImage($event, data.index)"
        (removeEvent)="onRemoveImageCell(data.index)"
      ></share-attachment>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/content/sns-send-message-content.component.html